export default __webpack_public_path__ + "static/media/f_heading.bcaa14be.svg";